import { getHeaderContent } from './selectors';

export const UPDATE_HEADER_CONTENT = 'UPDATE_HEADER_CONTENT';
export const HEADER_LOADING_KEY = 'isHeaderLoading';
const updateHeaderImageAction = (payload: object) => ({
    type: UPDATE_HEADER_CONTENT,
    payload,
});

export const UPDATE_HEADER_LOADING = 'UPDATE_HEADER_LOADING';
const updateHeaderLoadingAction = (isLoading: boolean) => ({
    type: UPDATE_HEADER_LOADING,
    payload: {
        [HEADER_LOADING_KEY]: isLoading,
    },
});
export const updateHeaderImage =
    () => (dispatch: Function, getState: Function) => {
        const {
            content: { seasonal },
            headerImageIndex,
            app: { tld, featureFlags },
            location: { slug },
        } = getState();

        const payload = getHeaderContent({
            seasonalContent: seasonal,
            fixedImageIndex: headerImageIndex,
            tld,
            locationSlug: slug,
            featureFlags,
        });
        dispatch(updateHeaderImageAction(payload));
    };

export const updateHeaderLoading =
    (isLoading: boolean) => (dispatch: Function) => {
        dispatch(updateHeaderLoadingAction(isLoading));
    };
